import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DtoUser from '../../home/dto/DtoUser'
import { PATH_ADMINISTRATION_ACCOUNT, PATH_ADMINISTRATION_CREDIT, PATH_ADMINISTRATION_THEME, PATH_HOME } from '../../home/constants/HomeConstants'
import i18n from 'simple-react-i18n'
import AppStore from '../../store/AppStore'
import { push } from 'react-router-redux'

class AdministrationApp extends Component {
	constructor(props) {
		super(props)
		this.state = {
			links: [
				{
					href: PATH_ADMINISTRATION_ACCOUNT,
					icons: 'person',
					name: i18n.myAccount
				},
				{
					href: PATH_ADMINISTRATION_CREDIT,
					icons: 'euro_symbol',
					name: i18n.credits
				},
				{
					href: PATH_ADMINISTRATION_THEME,
					icons: 'view_quilt',
					name: i18n.themes
				}
			]
		}
	}

	componentWillMount(): void {
		if (!this.props.isLogged) {
			AppStore.dispatch(push(PATH_HOME))
		}
	}

	render() {
		return (
			<div className='row no-margin'>
				<div className='col s12'>
					{ this.props.children }
				</div>
			</div>
		)
	}
}


AdministrationApp.propTypes = {
	user: PropTypes.objectOf(DtoUser),
	login: PropTypes.string,
	children: PropTypes.element,
	isLogged: PropTypes.bool
}

AdministrationApp.defaultProps = {
	user: {
		address: '',
		administrator: false,
		administratorUser: '',
		city: '',
		email: '',
		firstName: '',
		fixNumber: '',
		lastName: '',
		latitude: '',
		login: '',
		longitude: '',
		mobileNumber: '',
		zoom: ''
	}
}

export default AdministrationApp



// WEBPACK FOOTER //
// ./src/administration/components/AdministrationApp.js